"use strict";

var RibbonSpool = require('../../products/components/RibbonSpool');

function isRibbon(component) {
  return component.acc_ribbon && component.acc_ribbon !== 'None' || Object.prototype.isPrototypeOf.call(RibbonSpool.prototype, component);
}

module.exports = isRibbon;